import { Box, Typography } from '@mui/material';
import React from 'react';
import globalStyles from '../../global';
import { getResponsiveSize } from '../../utils/responsive';
import LeadersComp from './LeadersComp';

const LaundryLeaders = ({ title, color, textColor }) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  return (
    <Box sx={[styles.box1, { backgroundColor: globalStyles.colors.white }]}>
      <Box sx={styles.box2}>
        <Box
          width={'100%'}
          display={'flex'}
          justifyContent={'space-between'}
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'center', md: 'center' }}
        >
          <Box width={{ xs: '100%', md: '40%' }} mb={{ xs: 4, md: 0 }}>
            <img
              src={`${imageBaseUrl}washingMachine.png`}
              alt="Franchise"
              width="100%"
              style={{ maxWidth: '100%' }}
            />
          </Box>
          <Box width={{ xs: '100%', md: '54%' }}>
            <Box sx={[styles.typography, { color: textColor }]}>
              {title}
            </Box>
            <Box mt={getResponsiveSize(2)} mb={'4px'}>
              <Typography
                variant="regular_text_ur"
                sx={{
                  color: textColor,
                  fontSize: {
              xs: "14px",
              md: "18px",
              lg: "18px",
            },
                }}
              >
             UClean, India’s #1 laundry brand, partners with Alliance
Laundry Systems, the world’s largest equipment manufacturer, to bring you a unique business opportunity.
Learn from the best about setting up &
scaling a laundry business in the UAE. Register Today - Here’s what you will learn:
              </Typography>
            </Box>
            <LeadersComp />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  box1: {
    backgroundColor: globalStyles.colors.base_light,
    width: '100%',
    paddingBottom: { xs: getResponsiveSize(6), sm: getResponsiveSize(8) },
  },
  box2: {
    width: { xs: '90%', sm: '80%', md: '75%' },
    margin: 'auto',
    paddingTop: { xs: getResponsiveSize(6), sm: getResponsiveSize(10) },
  },
  typography: {
    color: globalStyles.colors.army_green,
    fontSize: {
      xs: getResponsiveSize(28),
      sm: getResponsiveSize(36),
      md: getResponsiveSize(45),
    },
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 700,
    lineHeight: 1.2,
  },
  button1: {
    backgroundColor: globalStyles.colors.white,
    color: globalStyles.colors.uclean_gold,
    height: { xs: getResponsiveSize(40), sm: getResponsiveSize(50) },
    fontSize: { xs: getResponsiveSize(14), sm: getResponsiveSize(16) },
    borderRadius: getResponsiveSize(10),
    border: `1px solid ${globalStyles.colors.uclean_gold} `,
    '&:hover': {
      backgroundColor: globalStyles.colors.white,
      color: globalStyles.colors.uclean_gold,
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
  },
};
export default LaundryLeaders;
